module.exports = __webpack_public_path__ + "static/media/OutOfTheList.61a40d42.png";